exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".HashTag-module__container--1-M5S {\r\n  width: 100%;\r\n  background-color: #f8f8f8;\r\n  padding: 24px 0px;\r\n  display: flex;\r\n  align-items: center;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.HashTag-module__tag--1eS0b {\r\n  margin-left: 16px;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  color: #ff7d40;\r\n  cursor: pointer;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"container": "HashTag-module__container--1-M5S",
	"tag": "HashTag-module__tag--1eS0b"
};